var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"picker",staticClass:"pickerComponent",style:({
    'background-color': ("rgb(" + (_vm.setRgb.r) + ", " + (_vm.setRgb.g) + ", " + (_vm.setRgb.b) + ")"),
  })})}
var staticRenderFns = []

export { render, staticRenderFns }